var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-combobox',{attrs:{"items":_vm.store.users,"item-text":"name","single-line":"","return-object":"","dense":"","outlined":""},on:{"change":_vm.onChange},model:{value:(_vm.user),callback:function ($$v) {_vm.user=$$v},expression:"user"}})}
var staticRenderFns = []

export { render, staticRenderFns }